'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
var $ = require("jquery");
var Header = /** @class */ (function () {
    function Header() {
        var _this = this;
        this.PC_WIDTH = 1200;
        this.INIT_PC_HEADER_HEIGHT = 60;
        $(window).on('load scroll', function (e) {
            _this.changeHeaderView(e);
        });
        $('.trigMenu').on('click', function (e) {
            _this.switchSpMenu(e);
        });
        $(window).on('resize', function () {
            _this.initNavi();
        });
    }
    // ナビを初期設定に戻す処理
    Header.prototype.initNavi = function () {
        if (this.isPcWidth()) {
            $('.bulletNavi').show();
            $('.bulletNavi').css('height', this.INIT_PC_HEADER_HEIGHT);
            $('.bulletNavi').attr('data-is-active', 'false');
            $('.paramMenu').attr('data-is-open', 'false');
            $('body').css('overflow', 'auto');
            $('.trigMenu').children('i').addClass('fa-navicon');
            $('.trigMenu').children('i').removeClass('fa-close');
            $('.paramMenu').attr('data-is-open', 'false');
            $('.bulletNavi').attr('data-is-active', 'false');
        }
        else {
            $('.bulletNavi').hide();
        }
    };
    // headerの表示切替
    Header.prototype.changeHeaderView = function (e) {
        var scroll = $(e.currentTarget).scrollTop();
        if (scroll > 0) {
            $('.bulletScroll').attr('data-is-mini', 'true');
        }
        else {
            $('.bulletScroll').attr('data-is-mini', 'false');
        }
    };
    // スマホメニューの開閉
    Header.prototype.switchSpMenu = function (e) {
        this.setNaviHeight();
        var isOpen = $(e.currentTarget).attr('data-is-open');
        if (isOpen === 'false') {
            $('body').css('overflow', 'hidden');
            $(e.currentTarget).children('i').removeClass('fa-navicon');
            $(e.currentTarget).children('i').addClass('fa-close');
            $('.bulletNavi').slideDown('slow', function () {
                $('.paramMenu').attr('data-is-open', 'true');
            });
            $('.bulletNavi').attr('data-is-active', 'true');
        }
        else {
            $('body').css('overflow', 'auto');
            $(e.currentTarget).children('i').addClass('fa-navicon');
            $(e.currentTarget).children('i').removeClass('fa-close');
            $('.bulletNavi').slideUp('slow', function () {
                $('.paramMenu').attr('data-is-open', 'false');
            });
            $('.bulletNavi').attr('data-is-active', 'false');
        }
    };
    // ナビの高さをセット
    Header.prototype.setNaviHeight = function () {
        var browserHeight = $(window).outerHeight();
        var headerHeight = $('.paramHeader').outerHeight();
        var height = browserHeight - headerHeight;
        $('.bulletNavi').css('height', height);
    };
    // PC以上の幅か判定
    Header.prototype.isPcWidth = function () {
        var isPcWidth = false;
        var browserWidth = $(window).outerWidth();
        if (browserWidth >= this.PC_WIDTH) {
            isPcWidth = true;
        }
        return isPcWidth;
    };
    return Header;
}());
exports.Header = Header;
exports.default = Header;
